<div data-cy="status-reason-dialog">
  <h1 mat-dialog-title data-cy="deal-disposition-header">Deal Disposition</h1>
  <div *ngIf="!confirmed">
    <div mat-dialog-content class="deal-status-reason-dialog">
      <div style="display: flex; justify-content: center"><mat-icon color="warn">warning</mat-icon></div>
      <p>You are about to Dead Out a previously funded deal.</p>
      <p>Are you sure you would like to continue?</p>
    </div>
    <mat-dialog-actions>
      <button mat-button mat-dialog-close>Cancel</button>
      <button mat-flat-button color="primary" (click)="confirmed = true">Confirm</button>
    </mat-dialog-actions>
  </div>
  <div *ngIf="confirmed">
    <div mat-dialog-content data-cy="deal-disposition" class="deal-status-reason-dialog">
      <p>Why are you moving this deal to "{{ data.selectedOption.value | dealStatusDisplay }}"?</p>

      <form [formGroup]="form">
        <formly-form [form]="form" [fields]="fields" [model]="model"></formly-form>
      </form>

    </div>
    <mat-dialog-actions>
      <button mat-button mat-dialog-close>Cancel</button>
      <button mat-flat-button [mat-dialog-close]="model" data-cy="change-status-btn" color="primary" [disabled]="!form.valid">Change Status</button>
    </mat-dialog-actions>
  </div>
</div>
